import { render, staticRenderFns } from "./RedeemForm.vue?vue&type=template&id=f1197584&scoped=true&"
import script from "./RedeemForm.vue?vue&type=script&lang=js&"
export * from "./RedeemForm.vue?vue&type=script&lang=js&"
import style0 from "./RedeemForm.vue?vue&type=style&index=0&id=f1197584&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1197584",
  null
  
)

export default component.exports